import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15e7a928"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]




export default /*#__PURE__*/_defineComponent({
  __name: 'VContent',
  props: {
    content: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ck ck-reset ck-content",
    innerHTML: props.content
  }, null, 8, _hoisted_1))
}
}

})